import { z } from 'zod';

export const ifaApprovalPostRequestSchema = z.object({
  approved: z.boolean(),
  company: z.string(),
  declaration_text: z.string(),
  email: z.string(),
});
